import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router";
import { Brand } from "./Brand";

export function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="shell footer-grid">
        <div className="footer-intro">
          <Brand />
          <p>把庞杂资料拆成可学的一步，让每一次理解、作答和复习都留下证据。</p>
        </div>
        <div className="footer-links">
          <div>
            <strong>产品</strong>
            <Link to="/download">下载</Link>
            <Link to="/roadmap">路线图</Link>
            <Link to="/releases">版本说明</Link>
          </div>
          <div>
            <strong>透明度</strong>
            <Link to="/#privacy">数据与隐私</Link>
            <a href="/updates/stable/latest.json">稳定版清单 <ArrowUpRight size={12} /></a>
            <Link to="/admin">管理后台</Link>
          </div>
        </div>
      </div>
      <div className="shell footer-bottom">
        <span>© 2026 StudyCoach</span>
        <span>Local-first · AI-assisted</span>
      </div>
    </footer>
  );
}
